import React, { useEffect, useState } from "react";
import { api, fmt } from "../lib/api";
import { Crown } from "lucide-react";

export default function Leaderboard() {
  const [tab, setTab] = useState("winnings");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/leaderboard?type=${tab}`).then(r=>setData(r.data.leaderboard)).catch(()=>{}).finally(()=>setLoading(false));
  }, [tab]);

  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-10">
      <h1 className="font-serif text-4xl gold-text mb-2 flex items-center gap-3"><Crown/>Leaderboard</h1>
      <p className="text-white/40 mb-6 text-sm">Top 20 · last 7 days</p>

      <div className="flex gap-2 mb-6">
        <button data-testid="lb-tab-winnings" onClick={()=>setTab("winnings")} className={`px-4 py-2 rounded-md text-xs uppercase tracking-widest ${tab==="winnings"?"btn-gold":"btn-ghost"}`}>Winnings</button>
        <button data-testid="lb-tab-volume" onClick={()=>setTab("volume")} className={`px-4 py-2 rounded-md text-xs uppercase tracking-widest ${tab==="volume"?"btn-gold":"btn-ghost"}`}>Volume</button>
      </div>

      <div className="lux-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-black/40 text-white/50 text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left p-3 w-12">#</th>
              <th className="text-left p-3">Player</th>
              <th className="text-left p-3">VIP</th>
              <th className="text-right p-3">Volume</th>
              <th className="text-right p-3">Winnings</th>
              <th className="text-right p-3">Net</th>
              <th className="text-right p-3">Rounds</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} className="p-6 text-center text-white/40">Loading…</td></tr>}
            {!loading && data.length===0 && <tr><td colSpan={7} className="p-6 text-center text-white/40">No data</td></tr>}
            {data.map((r,i)=>(
              <tr key={r.user_id} className="border-t border-white/5" data-testid={`lb-row-${i}`}>
                <td className="p-3 font-serif text-lg" style={{color: i===0?"#d4af37":i===1?"#c0c0c0":i===2?"#cd7f32":"#666"}}>{i+1}</td>
                <td className="p-3 flex items-center gap-2">
                  {r.picture && <img src={r.picture} alt="" className="w-7 h-7 rounded-full"/>}
                  <span>{r.name}</span>
                </td>
                <td className="p-3"><span className="text-xs uppercase tracking-widest" style={{color:r.vip.color}}>{r.vip.name}</span></td>
                <td className="p-3 text-right">{fmt(r.total_bet_huf, "HUF")}</td>
                <td className="p-3 text-right text-[#d4af37]">{fmt(r.total_win_huf, "HUF")}</td>
                <td className={`p-3 text-right ${r.net_huf>=0?"text-emerald-400":"text-red-400"}`}>{fmt(r.net_huf, "HUF")}</td>
                <td className="p-3 text-right text-white/50">{r.rounds}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
